export function Loading() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <p>Loading...</p>
    </div>
  );
}
